import {
  Flex,
  Heading,
  HStack,
  Image,
  Text,
  useTheme,
  VStack,
} from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import { REPOSITORY } from '../../../api/repository/Repository'
import Card from '../../../components/Card/Card'
import CardBody from '../../../components/Card/CardBody'
import CardHeader from '../../../components/Card/CardHeader'
import CardList from '../../../components/CardList/CardList'
import circleDollar from '../../../utils/assets/icons-dollar-circle.png'
import warning from '../../../utils/assets/icons-error.png'
import { useLabels } from '../../../utils/hooks/useLabels/useLabels'
import PaymentData from './PaymentData'

const cacheOptions = { cacheTime: 50000, staleTime: 50000 }

function CardsSection() {
  const indicators = useQuery(
    ['indicators'],
    REPOSITORY.wsEmpresa.dashboard.getCardsData,
    cacheOptions,
  )?.data?.data

  const handleNews = () => {
    window.open('https://www.amipass.com/aminews/', '_blank')
  }

  const { texts } = useLabels()
  const theme = useTheme()

  const pagosPendientesRaw = Number(indicators?.PagosPendientes || 0)
  const isPagoPendiente = pagosPendientesRaw > 0
  const isSaldoAFavor = pagosPendientesRaw < 0
  const pagoColor = isPagoPendiente
    ? theme.colors.log.error
    : theme.colors.primary.base
  const pagoDisplay = isPagoPendiente ? pagosPendientesRaw : 0

  return (
    <CardList justify="center" gap="20px">
      <Card
        flex="1"
        h="180px"
        minW={250}
        variant="panel"
        borderRadius={5}
        borderType="none"
        style={{ boxShadow: 'none' }}
      >
        <CardHeader>
          <HStack>
            <Image src={circleDollar} />
            <Text variant="subtitle2">{texts.avaible_credit}</Text>
          </HStack>
        </CardHeader>
        <CardBody>
          <VStack spacing={0}>
            <Heading variant="h2" color={theme.colors.primary.base}>
              $
              {Number(indicators?.SaldoDisponibleRecarga || 0).toLocaleString(
                'de-DE',
              )}
            </Heading>
            <Text
              as={Link}
              color="#0086D6"
              variant="caption1"
              to={'/company/account-status'}
            >
              Revisa tu estado de cuenta aquí
            </Text>
          </VStack>
        </CardBody>
      </Card>
      <Card
        flex="1"
        h="180px"
        minW={250}
        variant="panel"
        borderRadius={5}
        borderType="none"
        style={{ boxShadow: 'none' }}
      >
        <CardHeader>
          <HStack>
            <Image src={warning} />
            <Text variant="subtitle2">{texts.pending_payments}</Text>
          </HStack>
        </CardHeader>
        <CardBody>
          <Flex direction="column">
            <Heading variant="h2" color={pagoColor}>
              ${pagoDisplay.toLocaleString('de-DE')}
            </Heading>
            {isSaldoAFavor && (
              <Text variant="caption1" color={pagoColor} mb="8px">
                (saldo a favor $
                {Math.abs(pagosPendientesRaw).toLocaleString('de-DE')})
              </Text>
            )}
            <PaymentData />
          </Flex>
        </CardBody>
      </Card>
      <Card
        p={0}
        flex="1"
        h="180px"
        minW={250}
        variant="panel"
        borderRadius={5}
        borderType="none"
        overflow="hidden"
        style={{ boxShadow: 'none' }}
      >
        <img
          objectFit="fill"
          padding="32px"
          style={{
            width: 'auto',
            height: '100%',
            cursor: 'pointer',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
          src="https://assetsamipass.blob.core.windows.net/companies/dashboard/news.png"
          alt="News"
          onClick={handleNews}
        />
      </Card>
    </CardList>
  )
}

CardsSection.propTypes = {
  data: PropTypes.shape({
    PagosPendientes: PropTypes.string,
    RecargaPromedio: PropTypes.string,
    SaldoDisponibleRecarga: PropTypes.string,
  }),
}

export default CardsSection
